// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".state.light:hover {\n  background-color: rgba(0,0,0,0.04);\n}\n.state.dark:hover {\n  background-color: rgba(255,255,255,0.04);\n}\n\n.state.light:focus {\n  background-color: rgba(0,0,0,0.12);\n}\n.state.dark:focus {\n  background-color: rgba(255,255,255,0.12);\n}", ""]);
// Exports
module.exports = exports;
